// pages/TractateList.js
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchWithAuth } from '../auth';
import Breadcrumbs from '../components/Breadcrumbs';
import AuxiliaryFolderCards from '../components/AuxiliaryFolderCards';

export default function TractateList() {
  const [tractates, setTractates] = useState([]);
  const [folders, setFolders] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const [tractatesRes, foldersRes] = await Promise.all([
          fetchWithAuth('/api/tractates/'),
          fetchWithAuth('/api/auxiliary-folders/?scope=global'),
        ]);
        if (!tractatesRes.ok) throw new Error('Failed to load tractates');
        const data = await tractatesRes.json();
        const folderData = foldersRes.ok ? await foldersRes.json() : [];
        if (!ignore) {
          setTractates(data);
          setFolders(folderData);
        }
      } catch {
        if (!ignore) setError('שגיאה בטעינת המסכתות');
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, []);

  return (
    <div className="container">
      <Breadcrumbs
      items={[
        { label: 'מסכתות' }, // current page (no /home)
      ]}
    />
      <div className="toolbar toolbar--center">
        <h2 style={{ marginInlineStart: 0 }}>מסכתות</h2>
      </div>

      {loading && <p className="muted">טוען…</p>}
      {error && <p style={{ color: 'crimson' }}>{error}</p>}

      {!loading && !error && (
        <>
          <AuxiliaryFolderCards
            folders={folders}
            buildTo={(folder) => `/auxiliary/${folder.id}`}
          />

          <div className="grid-autofit" style={{ marginTop: folders.length ? '1.5rem' : undefined }}>
            {tractates.map(t => {
              const isEmergency = t.name === 'מיקוד מלחמה תשפו ולמידה בשעת חירום';
              const to = isEmergency ? '/emergency' : `/tractates/${t.id}`;
              const Image = (
                t.image
                  ? <img className="c-card__media" src={t.image} alt={t.name} />
                  : <div className="c-card__media" />
              );

              return (
                <article
                  key={t.id}
                  className="c-card"
                >
                  <Link to={to} className="card-media-wrap">
                    {Image}
                  </Link>

                  <div className="c-card__body">
                    <h3 className="c-card__title">
                      <Link to={to}>{t.name}</Link>
                    </h3>
                    <p className="c-card__meta">לחצו כדי להיכנס</p>
                  </div>
                </article>
              );
            })}
          </div>
        </>
      )}

      {!loading && !error && tractates.length === 0 && folders.length === 0 && (
        <p className="muted" style={{ textAlign: 'center' }}>
          אין מסכתות להצגה עדיין.
        </p>
      )}
    </div>
  );
}

